<div
  layout
  layout-vertical
  padding-lr-medium
  padding-tb
  gap-small
  layout-justify-center
  layout-align-items-center
>
  <rt-icon name="visibility-off" size="large-x" colorToken="colorIconDisabled" />
  <div text-center>
    {{ message() }}
  </div>
  @if (candidate() && canReveal()) {
    <rt-reveal-button
      [candidate]="candidate()!"
      [skipConfirmation]="skipRevealConfirmation()"
      (saveDontAskAgain)="saveSkipRevealConfirmation.emit()"
      (toggleDataVisibility)="toggleDataVisibility.emit($event)"
    />
  }
</div>
